import { Avatar, Link, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';
import { PurpleArrowDown2 } from 'Images';
import { isDesktop } from 'react-device-detect';
import { useNavigate } from 'react-router-dom';

export const LinkAllUpdates = () => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.Home).userUpdates;
  const navigate = useNavigate();

  return (
    <Link
      onClick={() => navigate('/updates')}
      underline='none'
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        m: '28px auto',
        height: isDesktop ? '50px' : '30px',
      }}
      tabIndex={0}
    >
      <Typography variant='body5'>{dictionary.allUpdates}</Typography>
      <Avatar
        alt=''
        src={PurpleArrowDown2}
        sx={{
          height: '44px',
          width: '50px',
          transform: 'rotate(90deg)',
          ml: 1,
        }}
      />
    </Link>
  );
};
